module.exports = __webpack_public_path__ + "static/media/psu.58853c48.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/project/fittrack/psu.png
// module id = 474
// module chunks = 0